import { Flex } from '@repo/ui/Flex';
import { Text } from '../../Language/Language';
import s from './ItemSelectionTask.module.css';
import sharedStyles from '../../shared/ShowMoreLink.module.css';

export const showMoreCutoff = 3;

export const ShowMoreButton = ({
  showMore,
  onClick,
  hiddenItemCount,
}: {
  showMore: boolean;
  onClick: () => void;
  hiddenItemCount?: number;
}) => {
  // Don't show button if already showing all items or no hidden items
  if (showMore || !hiddenItemCount || hiddenItemCount <= 0) {
    return null;
  }

  return (
    <Flex className={s.showMore}>
      <button
        onClick={onClick}
        className={sharedStyles.showMoreLink}
        type="button"
      >
        <Text
          langKey="pdx.global.show_more_items"
          replacementTokens={{
            count: hiddenItemCount.toString(),
          }}
        />
      </button>
    </Flex>
  );
};
